export default [
  {
    path: "/qrcode/:name/:url",
    props: true,
    component: () => import("../Main.vue")
  }
]
